/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Certificate } from '../models';
// @ts-ignore
import type { Document } from '../models';
// @ts-ignore
import type { DocumentStructure } from '../models';
// @ts-ignore
import type { InputDeleteDocumentFromArchive } from '../models';
// @ts-ignore
import type { ResponseCategoryAvailableForSpecificDocumentItem } from '../models';
// @ts-ignore
import type { ResponseListDocumentInArchiveItem } from '../models';
// @ts-ignore
import type { ResponseSearchInner } from '../models';
/**
 * DocumentApi - axios parameter creator
 * @export
 */
export const DocumentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary get list of certificates\'s category availables
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allCertificates: async (citizenId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/personal-archive/certificate/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (citizenId !== undefined) {
                localVarQueryParameter['citizenId'] = citizenId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get list of document\'s category availables
         * @param {number} personId 
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryAvailableForSpecificDocument: async (personId: number, citizenId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('categoryAvailableForSpecificDocument', 'personId', personId)
            const localVarPath = `/document/personal-archive/category/{personId}/`
                .replace(`{${"personId"}}`, encodeURIComponent(String(personId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (citizenId !== undefined) {
                localVarQueryParameter['citizenId'] = citizenId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"delete\", \"Document\"] 
         * @summary Delete document from archive | Permission required: [\"delete\", \"Document\"]
         * @param {InputDeleteDocumentFromArchive} [inputDeleteDocumentFromArchive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentFromArchive: async (inputDeleteDocumentFromArchive?: InputDeleteDocumentFromArchive, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/personal-archive/manager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputDeleteDocumentFromArchive, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get list of document\'s versions or direct document
         * @param {number} personId 
         * @param {number} categoryId 
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsByCategoryAndPerson: async (personId: number, categoryId: number, citizenId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'personId' is not null or undefined
            assertParamExists('getDocumentsByCategoryAndPerson', 'personId', personId)
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('getDocumentsByCategoryAndPerson', 'categoryId', categoryId)
            const localVarPath = `/document/personal-archive/category/{personId}/{categoryId}/`
                .replace(`{${"personId"}}`, encodeURIComponent(String(personId)))
                .replace(`{${"categoryId"}}`, encodeURIComponent(String(categoryId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (citizenId !== undefined) {
                localVarQueryParameter['citizenId'] = citizenId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a document from archive with matching queries
         * @param {number} documentStructureId 
         * @param {number} [referrerPersonId] 
         * @param {number} [yearReference] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchingDocumentFromArchive: async (documentStructureId: number, referrerPersonId?: number, yearReference?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'documentStructureId' is not null or undefined
            assertParamExists('getMatchingDocumentFromArchive', 'documentStructureId', documentStructureId)
            const localVarPath = `/document/personal-archive/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (documentStructureId !== undefined) {
                localVarQueryParameter['documentStructureId'] = documentStructureId;
            }

            if (referrerPersonId !== undefined) {
                localVarQueryParameter['referrerPersonId'] = referrerPersonId;
            }

            if (yearReference !== undefined) {
                localVarQueryParameter['yearReference'] = yearReference;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get list of document counts in archive
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocumentInArchive: async (citizenId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/personal-archive/manager`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (citizenId !== undefined) {
                localVarQueryParameter['citizenId'] = citizenId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"update\", \"Account\"] 
         * @summary Get all document structures
         * @param {number} categoryId 
         * @param {ListDocumentStructureByCategoryAndTargetTargetEnum} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocumentStructureByCategoryAndTarget: async (categoryId: number, target: ListDocumentStructureByCategoryAndTargetTargetEnum, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'categoryId' is not null or undefined
            assertParamExists('listDocumentStructureByCategoryAndTarget', 'categoryId', categoryId)
            // verify required parameter 'target' is not null or undefined
            assertParamExists('listDocumentStructureByCategoryAndTarget', 'target', target)
            const localVarPath = `/document/structure`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (categoryId !== undefined) {
                localVarQueryParameter['categoryId'] = categoryId;
            }

            if (target !== undefined) {
                localVarQueryParameter['target'] = target;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get list of searched  documents in archive
         * @param {string} qry 
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search: async (qry: string, citizenId?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'qry' is not null or undefined
            assertParamExists('search', 'qry', qry)
            const localVarPath = `/document/personal-archive/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (citizenId !== undefined) {
                localVarQueryParameter['citizenId'] = citizenId;
            }

            if (qry !== undefined) {
                localVarQueryParameter['qry'] = qry;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"create\", \"Document\"] 
         * @summary Upload document on archive | Permission required: [\"create\", \"Document\"]
         * @param {number} [id] 
         * @param {number} [documentStructureId] 
         * @param {number} [referrerPersonId] 
         * @param {number} [yearReference] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentOnArchive: async (id?: number, documentStructureId?: number, referrerPersonId?: number, yearReference?: number, files?: Array<File>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/document/personal-archive/`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


            if (id !== undefined) { 
                localVarFormParams.append('id', id as any);
            }
    
            if (documentStructureId !== undefined) { 
                localVarFormParams.append('documentStructureId', documentStructureId as any);
            }
    
            if (referrerPersonId !== undefined) { 
                localVarFormParams.append('referrerPersonId', referrerPersonId as any);
            }
    
            if (yearReference !== undefined) { 
                localVarFormParams.append('yearReference', yearReference as any);
            }
                if (files) {
                files.forEach((element) => {
                    localVarFormParams.append('files', element as any);
                })
            }

    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DocumentApi - functional programming interface
 * @export
 */
export const DocumentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DocumentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary get list of certificates\'s category availables
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async allCertificates(citizenId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Certificate>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.allCertificates(citizenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.allCertificates']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get list of document\'s category availables
         * @param {number} personId 
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async categoryAvailableForSpecificDocument(personId: number, citizenId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResponseCategoryAvailableForSpecificDocumentItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.categoryAvailableForSpecificDocument(personId, citizenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.categoryAvailableForSpecificDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"delete\", \"Document\"] 
         * @summary Delete document from archive | Permission required: [\"delete\", \"Document\"]
         * @param {InputDeleteDocumentFromArchive} [inputDeleteDocumentFromArchive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteDocumentFromArchive(inputDeleteDocumentFromArchive?: InputDeleteDocumentFromArchive, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteDocumentFromArchive(inputDeleteDocumentFromArchive, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.deleteDocumentFromArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get list of document\'s versions or direct document
         * @param {number} personId 
         * @param {number} categoryId 
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDocumentsByCategoryAndPerson(personId: number, categoryId: number, citizenId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Document>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDocumentsByCategoryAndPerson(personId, categoryId, citizenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.getDocumentsByCategoryAndPerson']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a document from archive with matching queries
         * @param {number} documentStructureId 
         * @param {number} [referrerPersonId] 
         * @param {number} [yearReference] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMatchingDocumentFromArchive(documentStructureId: number, referrerPersonId?: number, yearReference?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Document>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMatchingDocumentFromArchive(documentStructureId, referrerPersonId, yearReference, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.getMatchingDocumentFromArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get list of document counts in archive
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDocumentInArchive(citizenId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResponseListDocumentInArchiveItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDocumentInArchive(citizenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.listDocumentInArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"update\", \"Account\"] 
         * @summary Get all document structures
         * @param {number} categoryId 
         * @param {ListDocumentStructureByCategoryAndTargetTargetEnum} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listDocumentStructureByCategoryAndTarget(categoryId: number, target: ListDocumentStructureByCategoryAndTargetTargetEnum, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DocumentStructure>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listDocumentStructureByCategoryAndTarget(categoryId, target, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.listDocumentStructureByCategoryAndTarget']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get list of searched  documents in archive
         * @param {string} qry 
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async search(qry: string, citizenId?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ResponseSearchInner>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.search(qry, citizenId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.search']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"create\", \"Document\"] 
         * @summary Upload document on archive | Permission required: [\"create\", \"Document\"]
         * @param {number} [id] 
         * @param {number} [documentStructureId] 
         * @param {number} [referrerPersonId] 
         * @param {number} [yearReference] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadDocumentOnArchive(id?: number, documentStructureId?: number, referrerPersonId?: number, yearReference?: number, files?: Array<File>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadDocumentOnArchive(id, documentStructureId, referrerPersonId, yearReference, files, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DocumentApi.uploadDocumentOnArchive']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DocumentApi - factory interface
 * @export
 */
export const DocumentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DocumentApiFp(configuration)
    return {
        /**
         * 
         * @summary get list of certificates\'s category availables
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        allCertificates(citizenId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Certificate>> {
            return localVarFp.allCertificates(citizenId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get list of document\'s category availables
         * @param {number} personId 
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        categoryAvailableForSpecificDocument(personId: number, citizenId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ResponseCategoryAvailableForSpecificDocumentItem>> {
            return localVarFp.categoryAvailableForSpecificDocument(personId, citizenId, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"delete\", \"Document\"] 
         * @summary Delete document from archive | Permission required: [\"delete\", \"Document\"]
         * @param {InputDeleteDocumentFromArchive} [inputDeleteDocumentFromArchive] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteDocumentFromArchive(inputDeleteDocumentFromArchive?: InputDeleteDocumentFromArchive, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.deleteDocumentFromArchive(inputDeleteDocumentFromArchive, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get list of document\'s versions or direct document
         * @param {number} personId 
         * @param {number} categoryId 
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDocumentsByCategoryAndPerson(personId: number, categoryId: number, citizenId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Document>> {
            return localVarFp.getDocumentsByCategoryAndPerson(personId, categoryId, citizenId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a document from archive with matching queries
         * @param {number} documentStructureId 
         * @param {number} [referrerPersonId] 
         * @param {number} [yearReference] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMatchingDocumentFromArchive(documentStructureId: number, referrerPersonId?: number, yearReference?: number, options?: RawAxiosRequestConfig): AxiosPromise<Document> {
            return localVarFp.getMatchingDocumentFromArchive(documentStructureId, referrerPersonId, yearReference, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get list of document counts in archive
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocumentInArchive(citizenId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ResponseListDocumentInArchiveItem>> {
            return localVarFp.listDocumentInArchive(citizenId, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"update\", \"Account\"] 
         * @summary Get all document structures
         * @param {number} categoryId 
         * @param {ListDocumentStructureByCategoryAndTargetTargetEnum} target 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listDocumentStructureByCategoryAndTarget(categoryId: number, target: ListDocumentStructureByCategoryAndTargetTargetEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentStructure>> {
            return localVarFp.listDocumentStructureByCategoryAndTarget(categoryId, target, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get list of searched  documents in archive
         * @param {string} qry 
         * @param {number} [citizenId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        search(qry: string, citizenId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ResponseSearchInner>> {
            return localVarFp.search(qry, citizenId, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"create\", \"Document\"] 
         * @summary Upload document on archive | Permission required: [\"create\", \"Document\"]
         * @param {number} [id] 
         * @param {number} [documentStructureId] 
         * @param {number} [referrerPersonId] 
         * @param {number} [yearReference] 
         * @param {Array<File>} [files] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadDocumentOnArchive(id?: number, documentStructureId?: number, referrerPersonId?: number, yearReference?: number, files?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.uploadDocumentOnArchive(id, documentStructureId, referrerPersonId, yearReference, files, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DocumentApi - interface
 * @export
 * @interface DocumentApi
 */
export interface DocumentApiInterface {
    /**
     * 
     * @summary get list of certificates\'s category availables
     * @param {number} [citizenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApiInterface
     */
    allCertificates(citizenId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Certificate>>;

    /**
     * 
     * @summary get list of document\'s category availables
     * @param {number} personId 
     * @param {number} [citizenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApiInterface
     */
    categoryAvailableForSpecificDocument(personId: number, citizenId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ResponseCategoryAvailableForSpecificDocumentItem>>;

    /**
     *  **Permission required**: [\"delete\", \"Document\"] 
     * @summary Delete document from archive | Permission required: [\"delete\", \"Document\"]
     * @param {InputDeleteDocumentFromArchive} [inputDeleteDocumentFromArchive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApiInterface
     */
    deleteDocumentFromArchive(inputDeleteDocumentFromArchive?: InputDeleteDocumentFromArchive, options?: RawAxiosRequestConfig): AxiosPromise<boolean>;

    /**
     * 
     * @summary get list of document\'s versions or direct document
     * @param {number} personId 
     * @param {number} categoryId 
     * @param {number} [citizenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApiInterface
     */
    getDocumentsByCategoryAndPerson(personId: number, categoryId: number, citizenId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<Document>>;

    /**
     * 
     * @summary Get a document from archive with matching queries
     * @param {number} documentStructureId 
     * @param {number} [referrerPersonId] 
     * @param {number} [yearReference] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApiInterface
     */
    getMatchingDocumentFromArchive(documentStructureId: number, referrerPersonId?: number, yearReference?: number, options?: RawAxiosRequestConfig): AxiosPromise<Document>;

    /**
     * 
     * @summary get list of document counts in archive
     * @param {number} [citizenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApiInterface
     */
    listDocumentInArchive(citizenId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ResponseListDocumentInArchiveItem>>;

    /**
     *  **Permission required**: [\"update\", \"Account\"] 
     * @summary Get all document structures
     * @param {number} categoryId 
     * @param {ListDocumentStructureByCategoryAndTargetTargetEnum} target 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApiInterface
     */
    listDocumentStructureByCategoryAndTarget(categoryId: number, target: ListDocumentStructureByCategoryAndTargetTargetEnum, options?: RawAxiosRequestConfig): AxiosPromise<Array<DocumentStructure>>;

    /**
     * 
     * @summary get list of searched  documents in archive
     * @param {string} qry 
     * @param {number} [citizenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApiInterface
     */
    search(qry: string, citizenId?: number, options?: RawAxiosRequestConfig): AxiosPromise<Array<ResponseSearchInner>>;

    /**
     *  **Permission required**: [\"create\", \"Document\"] 
     * @summary Upload document on archive | Permission required: [\"create\", \"Document\"]
     * @param {number} [id] 
     * @param {number} [documentStructureId] 
     * @param {number} [referrerPersonId] 
     * @param {number} [yearReference] 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApiInterface
     */
    uploadDocumentOnArchive(id?: number, documentStructureId?: number, referrerPersonId?: number, yearReference?: number, files?: Array<File>, options?: RawAxiosRequestConfig): AxiosPromise<any>;

}

/**
 * DocumentApi - object-oriented interface
 * @export
 * @class DocumentApi
 * @extends {BaseAPI}
 */
export class DocumentApi extends BaseAPI implements DocumentApiInterface {
    /**
     * 
     * @summary get list of certificates\'s category availables
     * @param {number} [citizenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public allCertificates(citizenId?: number, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).allCertificates(citizenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get list of document\'s category availables
     * @param {number} personId 
     * @param {number} [citizenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public categoryAvailableForSpecificDocument(personId: number, citizenId?: number, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).categoryAvailableForSpecificDocument(personId, citizenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"delete\", \"Document\"] 
     * @summary Delete document from archive | Permission required: [\"delete\", \"Document\"]
     * @param {InputDeleteDocumentFromArchive} [inputDeleteDocumentFromArchive] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public deleteDocumentFromArchive(inputDeleteDocumentFromArchive?: InputDeleteDocumentFromArchive, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).deleteDocumentFromArchive(inputDeleteDocumentFromArchive, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get list of document\'s versions or direct document
     * @param {number} personId 
     * @param {number} categoryId 
     * @param {number} [citizenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getDocumentsByCategoryAndPerson(personId: number, categoryId: number, citizenId?: number, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).getDocumentsByCategoryAndPerson(personId, categoryId, citizenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a document from archive with matching queries
     * @param {number} documentStructureId 
     * @param {number} [referrerPersonId] 
     * @param {number} [yearReference] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public getMatchingDocumentFromArchive(documentStructureId: number, referrerPersonId?: number, yearReference?: number, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).getMatchingDocumentFromArchive(documentStructureId, referrerPersonId, yearReference, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get list of document counts in archive
     * @param {number} [citizenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public listDocumentInArchive(citizenId?: number, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).listDocumentInArchive(citizenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"update\", \"Account\"] 
     * @summary Get all document structures
     * @param {number} categoryId 
     * @param {ListDocumentStructureByCategoryAndTargetTargetEnum} target 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public listDocumentStructureByCategoryAndTarget(categoryId: number, target: ListDocumentStructureByCategoryAndTargetTargetEnum, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).listDocumentStructureByCategoryAndTarget(categoryId, target, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get list of searched  documents in archive
     * @param {string} qry 
     * @param {number} [citizenId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public search(qry: string, citizenId?: number, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).search(qry, citizenId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"create\", \"Document\"] 
     * @summary Upload document on archive | Permission required: [\"create\", \"Document\"]
     * @param {number} [id] 
     * @param {number} [documentStructureId] 
     * @param {number} [referrerPersonId] 
     * @param {number} [yearReference] 
     * @param {Array<File>} [files] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DocumentApi
     */
    public uploadDocumentOnArchive(id?: number, documentStructureId?: number, referrerPersonId?: number, yearReference?: number, files?: Array<File>, options?: RawAxiosRequestConfig) {
        return DocumentApiFp(this.configuration).uploadDocumentOnArchive(id, documentStructureId, referrerPersonId, yearReference, files, options).then((request) => request(this.axios, this.basePath));
    }
}

/**
 * @export
 */
export const ListDocumentStructureByCategoryAndTargetTargetEnum = {
    Personal: 'personal',
    Family: 'family'
} as const;
export type ListDocumentStructureByCategoryAndTargetTargetEnum = typeof ListDocumentStructureByCategoryAndTargetTargetEnum[keyof typeof ListDocumentStructureByCategoryAndTargetTargetEnum];
